import promisify from './promisify';

export default function geocode(
  options: google.maps.GeocoderRequest
): Promise<google.maps.GeocoderResult[]> {
  // https://developers.google.com/maps/documentation/javascript/geocoding#Geocoding
  const geocoder = new google.maps.Geocoder();

  return promisify<[google.maps.GeocoderRequest], google.maps.GeocoderResult[]>(
    geocoder.geocode.bind(geocoder)
  )(options);
}
